import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { QrCode, Printer } from "lucide-react";
import { getJobQrDataUrl, getJobQrInfo } from "../lib/qr";

// Cihaz QR etiketi (sticker) önizleme + yazdırma. Etiket: 50x50 mm, tek QR + marka/model + telefon.
export default function QrSticker({ jobId, phone = "0544 444 4 004", open, onOpenChange }) {
  const [img, setImg] = useState("");
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open || !jobId) return;
    setErr(""); setImg(""); setInfo(null);
    Promise.all([getJobQrDataUrl(jobId), getJobQrInfo(jobId)])
      .then(([i, n]) => { setImg(i); setInfo(n); })
      .catch((e) => setErr(e?.response?.data?.detail || "QR oluşturulamadı"));
  }, [open, jobId]);

  const print = () => {
    const w = window.open("", "_blank", "width=420,height=520");
    if (!w) { window.print(); return; }
    w.document.write(`<html><head><title>QR Etiket</title><style>
      @page{size:50mm 50mm;margin:0} body{margin:0;font-family:Arial,sans-serif}
      .s{width:50mm;height:50mm;box-sizing:border-box;padding:2mm;text-align:center}
      .s img{width:34mm;height:34mm;display:block;margin:0 auto}
      .b{font-weight:700;font-size:8pt;margin-top:1mm} .t{font-size:6.5pt;line-height:1.2}
    </style></head><body><div class="s"><img src="${img}"/><div class="b">${(info?.brand || "")} ${(info?.model || "")}</div>
    <div class="t">Servis geçmişi ve yeni talep için okutun<br/>${phone}</div></div>
    <script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`);
    w.document.close();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="qr-sticker-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><QrCode className="h-5 w-5" /> Cihaz QR Etiketi</DialogTitle></DialogHeader>
        {err ? <div className="text-sm text-rose-600">{err}</div> : !img ? <div className="text-sm text-slate-500 py-8 text-center">Hazırlanıyor…</div> : (
          <div className="mx-auto w-[220px] border-2 border-dashed border-slate-300 rounded-xl p-3 text-center bg-white" data-testid="qr-sticker-preview">
            <img src={img} alt="QR" className="w-40 h-40 mx-auto" />
            <div className="font-bold text-sm mt-1">{info?.brand} {info?.model}</div>
            <div className="text-[11px] text-slate-600 leading-tight">Servis geçmişi ve yeni talep için okutun<br />{phone}</div>
          </div>
        )}
        <p className="text-xs text-slate-500">Etiketi cihazın üzerine yapıştırın. Müşteri okutunca garanti durumunu, servis geçmişini görür ve tek dokunuşla servis çağırır.</p>
        <Button onClick={print} disabled={!img} data-testid="qr-sticker-print"><Printer className="h-4 w-4 mr-2" /> Etiketi yazdır</Button>
      </DialogContent>
    </Dialog>
  );
}
